<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
    mounted() {
    new this.$wow.WOW().init()
},
};
</script>

<style>
* {
  margin: 0;
}
body {
  /* background: #F8F8F8; */
}
#app{
  /* max-width: 1920px !important; */
  min-width: 1280px !important;
  /* margin: 0 auto; */
}
</style>
